module.exports = __webpack_public_path__ + "img/ZHWLRJKF_2.77fed22e.jpg";